<div class="output-label">
  <span>{{ position }}</span>
  @if (showOutputName) {
    <span>-</span><span>{{ output.name }}</span>
  }
</div>
@if (hasShapeIndicator$ | async) {
  @if (is3DOutput) {
    <mat-icon svgIcon="cuboid"></mat-icon>
  } @else {
    <mat-icon svgIcon="rectangle-shape-type"></mat-icon>
  }
}
@if (hasProjectionIndicator$ | async) {
  <mat-icon [h3CustomIcon]="projectionIndicatorIcon"></mat-icon>
}
